export default "__VITE_ASSET__BskvGKqb__"